var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faultReporting"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"title"},[_vm._v(" 国内咖啡消费变化趋势 ")])]),_c('div',{staticClass:"bottom"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"echartsLine"}})])])
}]

export { render, staticRenderFns }